import React, { useState } from 'react';
import MixedChart from '../charts/MixedChart';
import DelayRender from '../DelayRender';
import useMetronome from '../utility/useMetronome';
import HamQuest from '../api/HamQuestGiver';
import { QuestRoute } from '../api/QuestRoutes';

const IncomeByHour = ({ ...props }) => {

    const [data, setData] = useState([]);

    useMetronome(() => {
        HamQuest.get(QuestRoute.dashboard.incomeByHour)
            .then(res => {
                res.length = new Date().getHours() + 1;
                setData(res)
            })
            .catch(ex => console.error(ex))
    }, 60000)

    const chartProps = {
        yAxis: '$ (Dollar)',
        xAxis: Array.from({ length: new Date().getHours() + 1 }, (_, hour) => hour.toString().padStart(2, '0') + ':00'),
        data: [
            {
                name: 'Washes',
                type: 'column',
                data: data.map(e => e.count)
            }, {
                name: 'Revenue',
                type: 'area',
                data: data.map(e => e.income)
            }
        ],
        // tooltipFormatter: (e) => console.log(e),
    }

    return (
        <DelayRender>
            <MixedChart chartProps={chartProps} />
        </DelayRender>
    );
}

export default IncomeByHour;